module.exports = __webpack_public_path__ + "img/waaarp_logo_text_wh.5c1dda7a.png";